import * as Sentry from "@sentry/react";
import { clearAuthCookies } from "./utils/cookieUtils";
import { clearLocalStorageKeepingHomepageChoice } from "../utils/homepageVersion";
import {
  AUTH_EVENTS,
  isLeavingPage,
  logAuthEventBeforeLeaving,
} from "../utils/authEventLog";

// import swal from "sweetalert";
// import { API } from "../Services/api-service";
// import { decrypt, encrypt } from "../Core/utils/others";
// import { getRole } from "../Core/utils/auth";

// const sessionExpired = () => {
//   const role = getRole()
//   swal({
//     title: "Session Expired",
//     text: "Continue working?",
//     icon: "warning",
//     buttons: ["No, go to home page.", "Yes, Login"],
//     closeOnClickOutside: false,
//     closeOnEsc: false,
//   }).then((login) => {
//     if (login) {
//       const userObj = localStorage.getItem("sandbox_user");
//       const user = decrypt(userObj);
//       const username = user.user_name;
//       swal({
//         title: "Login",
//         text: "Enter your password.",
//         content: {
//           element: "input",
//           attributes: {
//             placeholder: "Type your password",
//             type: "password",
//           },
//         },
//         closeOnClickOutside: false,
//         closeOnEsc: false,
//       })
//         .then((password) => {
//           return API.post("/logInByMail", {
//             email: username,
//             password: password,
//             userType: role
//           });
//         })
//         .then((res) => {
//           if (res) {
//             const encryptedUserData = encrypt(res.data);
//             localStorage.setItem("sandbox_user", encryptedUserData);
//             window.location.reload();
//           }
//         })
//         .catch((e) => {
//           if (e.response?.data?.msg === "Wrong Password") {
//             localStorage.removeItem("sandbox_user");
//             window.location.replace("/");
//           }
//         });
//     } else {
//       localStorage.removeItem("sandbox_user");
//       window.location.replace("/");
//     }
//   });
// };
// import CryptoJS from "crypto-js";
// import AES from "crypto-js/aes";
// import { decrypt } from "./utils/others";

// const sessionExpired = () => {
//   const decryptedData = localStorage.getItem("sud")
//     ? JSON.parse(
//         AES.decrypt(localStorage.getItem("sud"), "secret key 123").toString(
//           CryptoJS.enc.Utf8,
//         ),
//       )
//     : decrypt(localStorage.getItem("sandbox_user"));
//   localStorage.removeItem("sandbox_user");
//   if (decryptedData.role === "student") {
//     window.location.replace("/#/login/student");
//   } else if (
//     decryptedData.role === "mentor" ||
//     decryptedData.role === "admin"
//   ) {
//     window.location.replace("/#/login/mentor");
//   } else {
//     window.location.replace("/");
//   }
// };

export const SESSION_EXPIRED_FLAG = "cy_session_expired";
export const SESSION_EXPIRED_MESSAGE = "Session expired, please login again.";

// Set once a session is being ended, so a request that 401s in the moment
// before the redirect doesn't end (and log) it a second time.
let sessionEnding = false;

/**
 * @param {string} [reason]  LOGOUT_REASONS value naming the call site
 * @param {object} [details] extra fields for the AUTH_SESSION_EXPIRED log
 */
const sessionExpired = (reason = "unknown", details = {}) => {
  if (sessionEnding) return;
  // A voluntary logout is already clearing the session and redirecting: a
  // request that 401s meanwhile must not turn it into "Session expired". Only
  // while nothing is stored, so any session that exists is always ended.
  if (isLeavingPage() && !localStorage.getItem("sandbox_user")) return;
  sessionEnding = true;

  // Built now, while the session is still in storage; sent in the background.
  logAuthEventBeforeLeaving(AUTH_EVENTS.SESSION_EXPIRED, {
    reason,
    ...details,
  });

  // Clear the cross-app cy-sso cookies FIRST — while the session is still
  // readable in localStorage — so clearAuthCookies can raise the
  // `cy_logged_out` signal for the student guard. No cy-sso api/logout here: it
  // would end the student's live session everywhere (see clearAuthCookies).
  // Then wipe local storage so a boot bootstrap can't re-create the (now
  // invalid) session and loop.
  clearAuthCookies(undefined, { notifyServer: false });
  clearLocalStorageKeepingHomepageChoice();
  Sentry.setUser(null);
  // Leave a one-shot marker so the login page (after the redirect below) shows
  // a "session expired" toast — instead of the old re-login popup.
  try {
    sessionStorage.setItem(SESSION_EXPIRED_FLAG, "1");
  } catch (_) {
    /* ignore */
  }
  // The log already went out with keepalive, so nothing waits for it.
  window.location.replace("/");
};

export default sessionExpired;
